import React, { useState, useEffect } from "react";
import HeroSection from "../components/features/home/HeroSection";
import PresentationSection from "../components/features/home/PresentationSection";
import SgMessageSection from "../components/features/home/SgMessageSection";
import FeaturesGridSection from "../components/features/home/FeaturesGridSection";
import TeamSection from "../components/features/home/TeamSection";
import CommuniquesHomeSection from "../components/features/home/CommuniquesHomeSection";
import PartnersHomeSection from "../components/features/home/PartnersHomeSection";
import StatsSection from "../components/features/home/StatsSection";
import AnimatedSection from "../components/common/AnimatedSection";
// import FaqSection from "../components/features/faq/FaqSection";
import SEO from "../components/common/SEO";

export default function Home() {
    const [teamData, setTeamData] = useState([]);

    useEffect(() => {
        fetch("/bureau_acem_fes/bureauData.json")
            .then((res) => res.json())
            .then((data) => setTeamData(data))
            .catch((err) => console.error("Erreur de chargement des membres du bureau:", err));
    }, []);

    const homeSchema = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "EducationalOrganization",
                "@id": "https://acem-fes.com/#organization",
                "name": "Association des Comoriens Étudiant au Maroc, Section Régionale de Fès",
                "alternateName": ["ACEM Fès", "Garadet"],
                "url": "https://acem-fes.com/",
                "logo": "https://acem-fes.com/logo.png",
                "image": "https://acem-fes.com/img_AG.jpeg",
                "description": "Plateforme officielle de l'Association des Comoriens Étudiant au Maroc (ACEM) section régionale de Fès. Démarches administratives, bibliothèque digitale, événements, communiqués officiels et vie associative.",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Fès",
                    "addressCountry": "MA"
                },
                "sameAs": [
                    "https://www.facebook.com/share/1anbGqXBfc/?mibextid=wwXIfr",
                    "https://www.instagram.com/acem_fes"
                ]
            },
            {
                "@type": "WebSite",
                "@id": "https://acem-fes.com/#website",
                "url": "https://acem-fes.com/",
                "name": "ACEM Fès – Plateforme Étudiante",
                "publisher": {
                    "@id": "https://acem-fes.com/#organization"
                },
                "inLanguage": "fr-FR"
            }
        ]
    };

    return (
        <div className="animate-fade-in space-y-0">
            <SEO
                title="Accueil"
                description="Plateforme officielle de l'Association des Comoriens Étudiant au Maroc, section régionale de Fès. Accompagnement étudiant, démarches, bibliothèque numérique et vie associative."
                canonical="/"
                image="/img_AG.jpeg"
                jsonLd={homeSchema}
            />
            <HeroSection />
            <div className="space-y-12 px-4 sm:px-6 pt-4 max-w-7xl mx-auto">
                <AnimatedSection animation="fade-up" className="my-2">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-stretch">
                        <PresentationSection />
                        <SgMessageSection teamData={teamData} />
                    </div>
                </AnimatedSection>
                <FeaturesGridSection />
                <TeamSection teamData={teamData} />
                <CommuniquesHomeSection />
                <PartnersHomeSection />
                {/* <FaqSection /> */}
                <StatsSection />
            </div>
        </div>
    );
}

